import * as React from 'react';
import { ButtonPriority, ButtonSize } from '../Button';

export type SplitActionSharedProps = {
  /** Specifies the skin. Applied to all children. */
  skin?: 'standard' | 'inverted' | 'premium' | 'transparent' | 'dark' | 'light';
  /** Specifies the priority. Applied to all children. */
  priority?: ButtonPriority;
  /** Controls the size. Applied to all children. */
  size?: ButtonSize;
  /** Specifies whether user interactions are disabled. Applied to all children. */
  disabled?: boolean;
};

export type SplitActionProps = SplitActionSharedProps & {
  /** Children: SplitActionButton and SplitActionIconButton */
  children?: React.ReactNode;
  /** Specifies a CSS class name to be appended to the component's root element. */
  className?: string;
  /** Applies a data-hook HTML attribute that can be used in the tests. */
  dataHook?: string;
};
